
import { useChangeLocale } from "@/hooks";
import { Locale } from "@/types";
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "LanguageSwitch",
  setup() {
    const { changeLocale, currentLocale } = useChangeLocale();

    const locales = computed(() => {
      return Object.values(Locale);
    });

    return { changeLocale, locales, currentLocale };
  },
});
